import {IManageUserState} from "@/typings/manageUser";
import {Module} from 'vuex';
import {IGlobalState} from '..';
import * as Types from '../action-types';

const state: IManageUserState = {
    adminType: "",
    schoolId: "",
    schoolName: "",
    token: "",
    userHeadImg: "",
    userId: "",
    userName: "",
    userType: "",
    name:""
};

const manageUser: Module<IManageUserState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_MANAGE_USER](state, payload: IManageUserState) {
            state.adminType = payload.adminType;
            state.schoolId = payload.schoolId
            state.schoolName = payload.schoolName
            state.token = payload.token
            state.userHeadImg = payload.userHeadImg
            state.userId = payload.userId
            state.userName = payload.userName
            state.userType = payload.userType
            state.name = payload.name


        }
    },
    actions: {
        [Types.SET_MANAGE_USER]({commit}, params) {
            commit(Types.SET_MANAGE_USER, params);
        },
    }
};
export default manageUser;